import {validateHTMLColorRgb } from "validate-color";

export function validate_rgbColor(data) {
    
    if( validateHTMLColorRgb(data) ) return true;

    return "txt162";

};
